import { useEffect, useState } from 'react';

// const baseUrl = "http://localhost:3001" //DEV
const baseUrl = 'https://cwc-backend-heroku.herokuapp.com'; //PRODUCTION

const useUploadImage = (token, images, upc) => {
	const [errorUploadImg, setErrorUploadImg] = useState(null);
	const [loadingUploadImage, setLoadingUploadImage] = useState(false);
	const [imageToUpload, setImageToUpload] = useState(null);

	const uploadImage = async (images, upc, fetchImgData) => {
		//check that is an image, or at least a File obj or trhow err
		if (!images || images.length === 0) {
			return;
		}

		//check we have a upc or throw err
		if (!upc) {
			return;
		}

		let imagesPayload = new FormData();

		if (images instanceof Array === false) {
			images = [images];
		}

		images.map((img, i) => {
			imagesPayload.append(upc, img);
		});

		console.log('DEBUG', 1, images, imagesPayload);

		//reset the data and loading
		setLoadingUploadImage(true);
		const options = {
			method: 'POST',
			headers: {
				Authorization: `Bearer ${token}`,
				// 'Content-Type': 'multipart/form-data',
			},
			body: imagesPayload,
		};
		const url = `${baseUrl}/inventory/images/upload/${upc}`;
		try {
			const response = await fetch(url, options);
			const parsedResponse = await response.json();
			console.log('[*] FILEUPLOAD RESPONSE', parsedResponse);

			if (parsedResponse.success === true) {
				//all good! image saved in s3!
				fetchImgData(upc);
				setLoadingUploadImage(false);
			}
		} catch (errorImgUpload) {
			setErrorUploadImg(errorImgUpload);
			setLoadingUploadImage(false);
			return console.error(errorImgUpload);
		}
	};

	useEffect(() => {
		if (!token || !upc || !images) return;

		uploadImage(upc, images);
	}, [token, upc, images]);

	return { errorUploadImg, loadingUploadImage, imageToUpload, uploadImage };
};

export default useUploadImage;
